import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-exportexcel',
  templateUrl: './exportexcel.component.html',
  styleUrls: ['./exportexcel.component.scss']
})
export class ExportexcelComponent implements OnInit {
  displayedData: any[] = [];
  study_crc_id: string | null = null;

  // Fixed titles for Site Monitoring Reports, CAPA Reports, and Monitoring Close Out Visits
  siteMonitoringReportTitles = [
    { title: 'Site Monitoring Report 1', form_no: 'form1' },
    { title: 'Site Monitoring Report 2', form_no: 'form2' },
    { title: 'Site Monitoring Report 3', form_no: 'form3' },
    { title: 'Site Monitoring Report 4', form_no: 'form4' },
    { title: 'Site Monitoring Report 5', form_no: 'form5' }
  ];
  capaReportTitles = [
    { title: 'CAPA Report 1', form_no: 'form1' },
    { title: 'CAPA Report 2', form_no: 'form2' },
    { title: 'CAPA Report 3', form_no: 'form3' },
    { title: 'CAPA Report 4', form_no: 'form4' },
    { title: 'CAPA Report 5', form_no: 'form5' }
  ];
  monitoringCloseOutVisitTitles = [
    { title: 'Monitoring Close Out Visit 1', form_no: 'form1' },
    { title: 'Monitoring Close Out Visit 2', form_no: 'form2' },
    { title: 'Monitoring Close Out Visit 3', form_no: 'form3' },
    { title: 'Monitoring Close Out Visit 4', form_no: 'form4' },
    { title: 'Monitoring Close Out Visit 5', form_no: 'form5' }
  ];

  constructor(private apiService: ApiService, private route: ActivatedRoute,private router: Router) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.study_crc_id = params.get('study_crc_id');

      if (this.study_crc_id) {
        this.apiService.getStudyMonitoringData(this.study_crc_id).subscribe(
          (data) => {
            this.displayedData = [
              ...this.siteMonitoringReportTitles.map((title) => {
                const rowData = data.find(
                  (row) => row.site_activity_name === 'Site Monitoring Report' && row.form_no === title.form_no
                ) || {};
                return {
                  Site_activity_name: title.title,
                  date: rowData.date || '',
                  reportLink: rowData.reportLink || '',
                  comment: rowData.comment || ''
                };
              }),
              ...this.capaReportTitles.map((title) => {
                const rowData = data.find(
                  (row) => row.site_activity_name === 'CAPA Report' && row.form_no === title.form_no
                ) || {};
                return {
                  Site_activity_name: title.title,
                  date: rowData.date || '',
                  reportLink: rowData.reportLink || '',
                  comment: rowData.comment || ''
                };
              }),
              ...this.monitoringCloseOutVisitTitles.map((title) => {
                const rowData = data.find(
                  (row) => row.site_activity_name === 'Monitoring close out visits' && row.form_no === title.form_no
                ) || {};
                return {
                  Site_activity_name: title.title,
                  date: rowData.date || '',
                  reportLink: rowData.reportLink || '',
                  comment: rowData.comment || ''
                };
              })              
            ];
          },
          (error) => {
            console.error('Error fetching study monitoring data:', error);
          }
        );
      } else {
        // Set empty rows with titles only if no data is found
        this.displayedData = [
          ...this.siteMonitoringReportTitles.map((title) => ({
            Site_activity_name: title.title,
            date: '',
            reportLink: '',
            comment: ''
          })),
          ...this.capaReportTitles.map((title) => ({
            Site_activity_name: title.title,
            date: '',
            reportLink: '',
            comment: ''
          })),
          ...this.monitoringCloseOutVisitTitles.map((title) => ({
            Site_activity_name: title.title,
            date: '',
            reportLink: '',
            comment: ''
          }))
        ];
      }
    });
  }

  exportToExcel() {
    const exportData = this.displayedData.map((row) => ({
      Site_activity_name: row.Site_activity_name,
      Date: row.date,
      'Report Link': row.reportLink,
      Comment: row.comment
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Study Monitoring Data');
    XLSX.writeFile(workbook, 'StudyMonitoringData.xlsx');
  }
  goBack(): void {
    const studyCrcId = this.study_crc_id ; // Use `study_crc_id` if available, otherwise default to '754'
    this.router.navigate(
        ['/study-crc-monitoring', studyCrcId], 
        {
            queryParams: {
                page: 1,
                searchCrcName: '',
                searchStudyName: '',
                searchLocation: '',
                searchAssignedBy: ''
            }
        }
    );
}


}
